/**
 * Base UI Input Component
 * Shared input wrapper that owns label, helper, and error presentation.
 */

import { useId } from 'react';
import { Input as BaseInput } from '@base-ui-components/react/input';
import {
  cn,
  gaiaTheme,
  getFieldHelperTextClasses,
  getFieldLabelClasses,
  getFieldRequiredClasses,
  getInputClasses,
} from './baseUIConfig';

function Input(props) {
  const {
    className = '',
    error = false,
    disabled = false,
    helperText,
    id,
    label,
    required = false,
    ref,
    ...other
  } = props;

  const generatedId = useId();
  const inputId = id || generatedId;
  const errorMessage = typeof error === 'string' ? error : '';
  const hasError = Boolean(error);
  const helperId = helperText && !hasError ? `${inputId}-helper` : undefined;
  const errorId = hasError && errorMessage ? `${inputId}-error` : undefined;
  const describedBy = errorId || helperId;

  return (
    <div className={gaiaTheme.components.field.container}>
      {label && (
        <label htmlFor={inputId} className={getFieldLabelClasses()}>
          {label}
          {required && <span className={getFieldRequiredClasses()}>*</span>}
        </label>
      )}

      <BaseInput
        ref={ref}
        id={inputId}
        className={getInputClasses(hasError, disabled, className)}
        disabled={disabled}
        aria-describedby={describedBy}
        aria-invalid={hasError ? 'true' : 'false'}
        {...other}
      />

      {errorId && (
        <p id={errorId} className={getFieldHelperTextClasses(true)}>
          {errorMessage}
        </p>
      )}

      {helperId && (
        <p id={helperId} className={cn(getFieldHelperTextClasses(false), 'mt-1')}>
          {helperText}
        </p>
      )}
    </div>
  );
}

export { Input };
export default Input;
